/**
 * Добавляет вспомогательный класс `utilityfocus` для элемента body.
 */
export const forceUtilityFocus = (): void => {
    window.document.body.classList.add('utilityfocus');
};
